import { gql } from '@apollo/client';

export const createAmendmentMutation = gql`
  mutation CreateAmendment($input: CreateAmendmentInput!) {
    production {
      createAmendment(input: $input)
    }
  }
`;

export const createCancellationAmendmentMutation = gql`
  mutation createCancellationAmendment($input: CreateAmendmentInput!) {
    production {
      createCancellationAmendment(input: $input)
    }
  }
`;

export const cancelAmendmentMutation = gql`
  mutation CancelAmendment($amendmentId: String!) {
    production {
      cancelAmendment(amendmentId: $amendmentId)
    }
  }
`;

export const calculateAmendmentMutation = gql`
  mutation CalculateAmendment(
    $amendmentId: String!
    $input: CalculateAmendmentInput!
  ) {
    production {
      calculateAmendment(amendmentId: $amendmentId, input: $input)
    }
  }
`;

export const confirmAmendmentMutation = gql`
  mutation ConfirmAmendment(
    $amendmentId: String!
    $input: ConfirmAmendmentInput!
  ) {
    production {
      confirmAmendment(amendmentId: $amendmentId, input: $input)
    }
  }
`;

export const confirmCancellationAmendmentMutation = gql`
  mutation ConfirmCancellationAmendment(
    $input:  ConfirmCancellationAmendmentInput!
  ) {
    production {
      confirmCancellationAmendment(input: $input)
    }
  }
`;
